import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { ScopeService } from '../utils';

@Injectable()
export class PermissionGuard  {

  constructor(
    private scopeService: ScopeService,
    private router: Router,
  ) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const permissionProperty = route.data.permissionProperty;

    if (!permissionProperty) {
      return of(true);
    }

    return this.scopeService.user$.pipe(
      filter((user) => user !== null),
      map((user) => user[permissionProperty] === true),
      tap((permission) => {
        if (!permission) {
          this.router.navigate(['misc', 'permission-denied']);
        }
      }),
    );
  }
}
